import { Icon } from 'rsuite';
import Header from '../../../../../../components/Header';
import { HEADER_ADERENCIA_PRECOS } from '../../data';
import styles from './HeaderAderenciaPrecos.module.scss';
import { getLastSaturday } from '../../utils';

export type HeaderAnaliseCoberturaProps = {
  onChangePeriod?: (value: number) => void;
  date?: string;
  status?: number | null;
};

export const HeaderAderenciaPrecos = ({ status, onChangePeriod }: HeaderAnaliseCoberturaProps) => {
  return (
    <Header
      subtitle={HEADER_ADERENCIA_PRECOS.subtitle}
      badgeLabel="Pro"
      icon={<Icon className={styles['bullseye-icon']} icon="bullseye" />}
      titleChildren={
        <div className={styles['header-title-wrapper']}>
          <span className={styles.title}>{HEADER_ADERENCIA_PRECOS.title}</span>
          {status === 200 ? (
            <div className={styles['header-update-info']}>
              <span>Atualizado em {getLastSaturday()}</span>
            </div>
          ) : null}
        </div>
      }
    />
  );
};
